import { trackEvent } from '~/utils/tracking'
import { Button } from '~/components/general/Button'

import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

import { useEffect } from 'react'
import { FlexContainer } from '~/components/Grid'
import { TypeHomePageBlock } from '~/types/contentful'

gsap.registerPlugin(ScrollTrigger)

type CareerPathwaysProps = {
  section: TypeHomePageBlock<'WITHOUT_UNRESOLVABLE_LINKS', string>
}

export const CareerPathways = ({ section }: CareerPathwaysProps) => {
  const data = section.fields

  useEffect(() => {
    const ctx = gsap.context(() => {
      const tl = gsap.timeline({
        scrollTrigger: {
          start: 'top center',
          trigger: '.block-career-trigger',
        },
      })
      tl.fromTo(
        '.animate-career-scheme',
        0.6,
        {
          clipPath: 'inset(0 271px 0 0)',
          x: 50,
          y: 0,
        },
        {
          clipPath: 'inset(0 0px 0 0)',
          x: 0,
          y: 10,
        },
      ).fromTo(
        '.animate-career-stars',
        0.6,
        {
          x: 40,
          y: 15,
          scale: 0.8,
        },
        {
          x: 0,
          y: 0,
          scale: 1,
        },
        '-=0.6',
      )
    })

    return () => ctx.revert()
  }, [])

  const handleCTABtnClick = () => {
    trackEvent('homepage_click_cta', {
      block: data.blockId,
      target: data.buttonLink as string,
      homepage_CTA: data.buttonName as string,
    })
  }

  return (
    <>
      <section
        data-block-id={data.blockId}
        className={
          'my-25 -mx-8 max-xl:my-10 max-xl:-mx-5 max-lg:my-25 max-lg:mx-6 max-md:-mx-4 block-career-trigger'
        }
      >
        <FlexContainer
          className="max-md:p-[65px_0_10px_0] max-lg:flex-col-reverse max-lg:min-h-fit max-lg:justify-end max-lg:gap-5 max-lg:items-center bg-neutral-5 overflow-hidden rounded-3xl gap-11 min-h-[572px] [&_img]:self-center"
          flexWrap={'nowrap'}
          justify={'start'}
        >
          <FlexContainer
            justify={'between'}
            flexWrap={'nowrap'}
            className="max-w-[550px] p-[87px_97px] max-lg:p-[30px_60px_40px] max-lg:max-w-100 relative flex-col gap-8 items-start max-md:justify-end max-md:m-0 max-md:min-w-[auto] max-md:py-5 max-md:px-10"
          >
            <h2 className="text-l">{data.title}</h2>
            <p className="max-md:hidden text-s">{data.description}</p>
            <Button
              text={data.buttonName}
              type={'link'}
              href={data.buttonLink}
              onClick={handleCTABtnClick}
              className="max-md:!self-center max-md:w-fit"
            />
          </FlexContainer>
          <div className="relative w-full flex max-lg:justify-end max-md:py-5 max-md:px-0">
            <img
              className="max-w-full mb-9 max-lg:mb-0 animate-career-scheme"
              src="/images/career-pathways_img.png"
              alt=""
              loading="lazy"
            />
            <img
              style={{
                position: 'absolute',
                left: '14%',
                top: '27%',
                width: 73,
              }}
              className={'animate-career-stars'}
              src="./images/career-effect.png"
              alt=""
              loading="lazy"
            />
          </div>
        </FlexContainer>
      </section>
    </>
  )
}
